
















































import Vue from 'vue';
import LandingHeader from '@/components/LandingHeader.vue';
import BottomButton from '@/components/BottomButton.vue';
import EnemResult from '@/components/results/EnemResult.vue';
import EssayResult from '@/components/results/EssayResult.vue';
import SecondGradAndTransferResult from '@/components/results/SecondGradAndTransferResult.vue';
import PendingApprovalResult from '@/components/results/PendingApprovalResult.vue';
import pipeline from '@/pipeline';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import { redirectEnrollment } from '@/helpers/location';

export default Vue.extend({
  components: {
    LandingHeader,
    BottomButton,
    EnemResult,
    EssayResult,
    SecondGradAndTransferResult,
    PendingApprovalResult,
  },
  computed: {
    isEnem(): boolean {
      return this.$store.getters.selectedAdmissionType?.stateKey === 'enem';
    },
    isEssay(): boolean {
      return this.$store.getters.selectedAdmissionType?.stateKey === 'essay';
    },
    isSecondGraduation(): boolean {
      return this.$store.getters.selectedAdmissionType?.stateKey === 'secondGraduation';
    },
    isTransfer(): boolean {
      return this.$store.getters.selectedAdmissionType?.stateKey === 'transferGraduation';
    },
    isExecuting(): boolean {
      return this.$store.getters.evaluationStatus === 'executing';
    },
    isSuccess(): boolean {
      return this.$store.getters.evaluationStatus === 'success';
    },
    isFailure(): boolean {
      return this.$store.getters.evaluationStatus === 'failure';
    },
    isRetryEssay(): boolean {
      return this.$store.getters.evaluationStatus === 'retryEssay';
    },
    isPendingApproval(): boolean {
      return this.$store.getters.evaluationStatus === 'pendingApproval';
    },
    userFirstName(): string {
      return this.$store.getters.userFirstName;
    },
    enemGradesAverage(): number {
      return this.$store.getters.enemGradesAverage;
    },
    essayGrade(): number {
      return this.$store.getters.essay?.grade || 0;
    },
  },
  created() {
    if (!pipeline.initialized) return;

    const { evaluationStatus } = this.$store.getters;

    this.$store.dispatch(AnalyticsActions.USER_APPLICATION_STATUS);

    const hasStatusChanged = pipeline.state.context.status !== evaluationStatus;

    if (hasStatusChanged) pipeline.send('UPDATE_PIPELINE_STATUS', { status: evaluationStatus });

    if (pipeline.state.context.isAtEnrollment) redirectEnrollment();
  },
  methods: {
    async retry() {
      if (this.isEssay) await this.$store.dispatch('UPDATE_ESSAY', { essay: null });
      else if (this.isEnem) await this.$store.dispatch('UPDATE_ENEM', { enem: null });
      else if (this.isSecondGraduation)
        await this.$store.dispatch('UPDATE_SECOND_GRADUATION', { secondGraduation: null });
      else if (this.isTransfer)
        await this.$store.dispatch('UPDATE_TRANSFER_GRADUATION', { transferGraduation: null });

      pipeline.next();
    },
    async startEnrollment() {
      pipeline.send('UPDATE_PIPELINE_ISATENROLLMENT', { isAtEnrollment: true });
      redirectEnrollment();
    },
  },
});
